<template>
  <div>
    <div class="flex flex-wrap items-center mb-4">
      <div class="w-full sm:w-1/3 mb-2 sm:mb-0 text-stone-700 dark:text-stone-300">
        {{ t('optionsdialog.Wheel background image') }}
      </div>
      <div class="w-full sm:w-2/3 relative">
        <!-- Custom dropdown -->
        <div class="relative" ref="rootEl">
          <!-- Dropdown trigger button -->
          <button @click="toggleDropdown"
            class="flex items-center px-3 py-2 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm bg-white dark:bg-stone-700 text-stone-700 dark:text-stone-200 hover:bg-stone-50 dark:hover:bg-stone-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
            <img :src="imageSrc" class="h-[30px] w-[30px] rounded-full mr-2" alt="Selected background image">
            <i :class="['fas ml-2', isOpen ? 'fa-caret-up' : 'fa-caret-down']"></i>
          </button>

          <!-- Dropdown menu -->
          <div v-if="isOpen"
            class="absolute z-10 mt-2 w-56 rounded-md shadow-lg bg-white dark:bg-stone-800 ring-1 ring-black ring-opacity-5 overflow-auto max-h-[400px]">
            <div class="py-1">
              <!-- Upload option -->
              <div class="px-4 py-2">
                <label
                  class="cursor-pointer inline-flex items-center px-3 py-2 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm bg-white dark:bg-stone-700 text-stone-700 dark:text-stone-200 hover:bg-stone-50 dark:hover:bg-stone-600">
                  <i class="fas fa-upload mr-2"></i>
                  {{ t('optionsdialog.Upload image') }}
                  <input type="file" class="hidden" accept="image/*" @change="onFileChange">
                </label>
              </div>

              <!-- Gallery images -->
              <div v-for="pic in coverImages" :key="pic.fileName" @click="selectGalleryImage(pic)"
                class="flex items-center px-4 py-2 text-sm text-stone-700 dark:text-stone-300 hover:bg-stone-100 dark:hover:bg-stone-700 cursor-pointer">
                <img :src="pic.fileName" class="h-[30px] w-[30px] rounded-full mr-2" :alt="pic.title">
                <span>{{ pic.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import coverImageList from './coverImageList.js';
import * as Util from '@utils/Util.js';
import * as ImageUtil from '@utils/ImageUtil.js';

const { t } = useI18n();
const emit = defineEmits(['set-background-gallery-image', 'set-background-uploaded-image']);
defineProps({ imageSrc: String });

const isOpen = ref(false);
const coverImages = coverImageList.list;
const rootEl = ref(null);

function toggleDropdown() {
  isOpen.value = !isOpen.value;
}
function clickOutside(event) {
  if (isOpen.value && rootEl.value && !rootEl.value.contains(event.target)) {
    isOpen.value = false;
  }
}
function selectGalleryImage(pic) {
  emit('set-background-gallery-image', pic.fileName);
  isOpen.value = false;
}
async function onFileChange(event) {
  const file = event.target.files[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = async (e) => {
    Util.trackEvent('Wheel', 'UploadedCustomImage', '');
    const dataUri = await ImageUtil.optimizeCoverImage(e.target.result);
    emit('set-background-uploaded-image', { fileName: file.name, dataUri });
    event.target.value = '';
    isOpen.value = false;
  };
  reader.readAsDataURL(file);
}

onMounted(() => document.addEventListener('click', clickOutside));
onBeforeUnmount(() => document.removeEventListener('click', clickOutside));
</script>
